import React, { useEffect } from 'react';

// Lightweight in-app modal (replaces window.prompt / confirm).
export default function Modal({ open, title, children, onClose, actions, testid }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') onClose && onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div className="modal-overlay" data-testid={testid || 'modal'} onMouseDown={onClose}>
      <div className="modal" onMouseDown={e => e.stopPropagation()}>
        {title && <h3>{title}</h3>}
        <div className="modal-body">{children}</div>
        {actions && <div className="modal-actions">{actions}</div>}
      </div>
    </div>
  );
}
